import React, {Component} from 'react';
import './styles/NavigationHeader.css';

import {Link, NavLink} from 'react-router-dom';
import links from '../../_Utilities/nav/links';

class NavigationHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            atTop: true,
            menu: {
                isOpen: false,
                label: 'Menu'
            }
        }
    }

    componentDidMount() {
        window.onscroll = () => {
            if (window.pageYOffset === 0) {
                this.setState({
                    atTop: true,
                })
            } else {
                this.setState({
                    atTop: false,
                })
            }
        };
    }

    componentWillUnmount() {
        window.onscroll = null;
    }

    toggleMenu = () => {
        if (this.state.menu.isOpen) {
            this.setState({
                menu: {
                    isOpen: false,
                    label: 'Menu'
                }
            })
        } else {
            this.setState({
                menu: {
                    isOpen: true,
                    label: '✖'
                }
            })
        }
    }

    closeMenu = () => {
        if (this.state.menu.isOpen) {
            this.setState({
                menu: {
                    isOpen: false,
                    label: 'Menu'
                }
            })
        }
    };

    render() {
        let isOpen = this.state.menu.isOpen;

        return (
            <div className={`nav ${this.state.atTop ? '' : 'solid'}`}>
                <div className={`nav__backdrop ${isOpen ? 'active' : ''}`} 
                    onClick={this.closeMenu}/>
                <div className={'nav__content'}>
                    <Link className={'nav__logo'} to={'/'} onClick={this.closeMenu}/>
                    <nav className={'nav__links'}>
                        {links.map((link, i) => {
                            return <NavLink key={i} className={'nav__link'} 
                                activeClassName={'nav__link--active'}
                                to={`/${link.href}`}>
                                    {link.title}
                                </NavLink>
                        })}
                    </nav>
                    <div className={"nav__menu"} onClick={this.toggleMenu}>
                        {this.state.menu.label}
                    </div>
                    <div className={`nav__expanded ${isOpen ? 'active' : ''}`}>
                        {links.map((link, i) => {
                            return <NavLink key={i} className={'nav__link'} 
                                activeClassName={'nav__link--active'}
                                to={`/${link.href}`}
                                onClick={this.toggleMenu}>{link.title}</NavLink>
                        })}
                    </div>
                </div>
            </div>
        )
    }
}

export default NavigationHeader;